<script>
  import FilterEventService from './filter-event-service.vue'

  export default {
    name: 'FilterEventSale',
    extends: FilterEventService,
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-event-sale.vue